import useNotifications from '@/composables/useNotifications'
import { useRouter } from '@core/utils/utils'
import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import { useLambda } from '@/views/habit/awsLambda'
import { oid, date } from '@/helpers/mongoHelpers'
import useCommon from "@/views/organization/useCommon"

export default function useRoleEdit() {
  const { showSuccessMessage, showErrorMessage } = useNotifications()
  const { router, route } = useRouter()
  const { getItem, updateItem } = useLambda()
  const { assignSupervisorsBasedOnRoles } = useCommon()
  const role = ref(null)
  const isSubmitting = ref(false)
  const query = { _id: oid(route.value.params.id) }
  const collection = 'role'

  const show = async () => {
    isSubmitting.value = true

    try {
      const item = await getItem({ collection, query })
      if (!item) throw new Error('Item not found')

      role.value = {
        ...item,
        subroles: item.subroles?.map((e) => e.toString()) || [],
        parentRoles: item.parentRoles?.map((e) => e.toString()) || [],
      }
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('message.role_fetch_error'))
    } finally {
      isSubmitting.value = false
    }
  }

  const update = async payload => {
    isSubmitting.value = true

    const parentRoles = payload.parentRoles || []

    payload.subroles = payload.subroles?.map(e => oid(e)) || []
    payload.parentRoles = parentRoles.map(e => oid(e))

    try {
      const action = { $set: payload }

      await updateItem({ collection, query, action })

      // Update supervisors of the workers that have this role based on the selected parent roles
      assignSupervisorsBasedOnRoles([route.value.params.id], parentRoles)

      showSuccessMessage(i18n.t('message.form_success'))
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('message.role_update_error'))
    } finally {
      router.push({ name: 'organization-role-list' })
      isSubmitting.value = false
    }
  }

  return {
    update,
    show,
    role,
    isSubmitting,
  }
}
